import * as Yup from "yup";
import PTFragment from "./PTFragment";

export type ConfigType = {
  component: JSX.Element;
  schema: typeof schema;
  initialValues: SchemaType;
  keysToExclude?: Partial<keyof SchemaType>[];
};

export type SchemaType = Yup.InferType<typeof schema>;

const schema = Yup.object({
  workCountry: Yup.string().oneOf(["PT"]).required("Required"),
  probationPeriodDays: Yup.string()
    .required("Required")
    .oneOf(["0", "90"], "Must be none or 90 days."),
  ptMealAllowance: Yup.boolean().required("Required"),
});

const CONFIG: ConfigType = {
  component: <PTFragment />,
  schema: schema,
  initialValues: {
    workCountry: "PT",
    probationPeriodDays: "0",
    ptMealAllowance: false,
  },
  keysToExclude: [],
};

export default CONFIG;
